import React from "react";

export const StytchInfoIcon = props => {
  const style = {
    ...props.style
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="13"
      viewBox="0 0 12 14"
      fill="none"
      style={style}
      {...props}
    >
      <g clip-path="url(#clip0_1473_130975)">
        <circle
          cx="6"
          cy="7.39941"
          r="5.625"
          stroke="black"
          stroke-width="0.75"
        />
        <path
          d="M5.5616 4.69941V3.75941H6.4416V4.69941H5.5616ZM5.5916 10.8994V5.89941H6.4116V10.8994H5.5916Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1473_130975">
          <rect
            width="12"
            height="13"
            fill="white"
            transform="translate(0 0.899414)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
